import React, { PureComponent } from 'react'

import { Button, ButtonColorVariant } from '@gousto-internal/citrus-react'
import { getReferralLink } from 'SocialLinks/socialReferralHelper'
import classnames from 'classnames'
import PropTypes from 'prop-types'

import { actionTypes } from 'actions/actionTypes'
import Overlay from 'components/Overlay'
import { SocialShareSheetContainer } from 'components/SocialLinks/SocialShareSheet'

import css from './SocialShareSheetCTA.css'

const propTypes = {
  referralCode: PropTypes.string.isRequired,
  isFixed: PropTypes.bool.isRequired,
  trackingReferFriend: PropTypes.func.isRequired,
}

class SocialShareSheetCTA extends PureComponent {
  constructor(props) {
    super(props)
    this.state = { isShareSheetOpen: false }
  }

  onClick = (referralLink) => {
    if (navigator.share) {
      navigator.share({
        title: "Here's my link to try Gousto!",
        url: referralLink,
        text: 'Use it to get 70% off your first box, PLUS 25% off all other boxes in your first two months.',
      })
        .catch(() => {})
      const { trackingReferFriend } = this.props
      trackingReferFriend(actionTypes.REFER_FRIEND_LINK_SHARE, 'NativeReferFriendInterface Opened')
    } else {
      this.openShareSheet()
    }
  }

  openShareSheet = () => {
    const { trackingReferFriend } = this.props
    trackingReferFriend(actionTypes.REFER_FRIEND_SHARE_SHEET_OPENED, 'ReferFriendShareSheet Opened')
    this.setState({ isShareSheetOpen: true })
  }

  closeShareSheet = () => {
    const { trackingReferFriend } = this.props
    trackingReferFriend(actionTypes.REFER_FRIEND_SHARE_SHEET_CLOSED, 'ReferFriendShareSheet Closed')
    this.setState({ isShareSheetOpen: false })
  }

  render() {
    const { isShareSheetOpen } = this.state
    const { referralCode, isFixed } = this.props
    const ctaContainerClasses = classnames(css.mobileShow, {
      [css.fixedMobileCTAContainer]: isFixed,
    })

    const referralLink = getReferralLink(referralCode, '', '&utm_source=weblink')

    return (
      <div className={ctaContainerClasses}>
        <Button
          onClick={() => this.onClick(referralLink)}
          colorVariant={ButtonColorVariant.Primary}
          width="100%"
        >
          Share your link
        </Button>
        <Overlay open={isShareSheetOpen} from="bottom">
          <SocialShareSheetContainer onClose={this.closeShareSheet} referralCode={referralCode} />
        </Overlay>
      </div>
    )
  }
}

SocialShareSheetCTA.propTypes = propTypes

export { SocialShareSheetCTA }
